export class ErrorBoundaryError extends Error {
  constructor(message, options) {
    super(message, options);
    this.errorType = 'ErrorBoundaryError';
    this.options = options;
  }
}
export const isErrorBoundaryError = error => error instanceof ErrorBoundaryError;